const TOKEN = /(\d+)|(\D+)/g;

function tokenize(code: string): (number | string)[] {
  const tokens: (number | string)[] = [];
  for (const match of code.trim().matchAll(TOKEN)) {
    const [, digits, other] = match;
    if (digits !== undefined) {
      tokens.push(Number(digits));
    } else if (other !== undefined) {
      tokens.push(other.toLowerCase());
    }
  }
  return tokens;
}

/**
 * Natural order for RISQ codes: `1.2` before `1.10`, `4.5` before `4.5a`, `9` before `10.1`.
 * Use this everywhere codes are sorted (CLAUDE.md "Code rules").
 */
export function compareRisqCodes(a: string, b: string): number {
  const left = tokenize(a);
  const right = tokenize(b);
  const length = Math.min(left.length, right.length);
  for (let i = 0; i < length; i += 1) {
    const x = left[i] as number | string;
    const y = right[i] as number | string;
    if (x === y) {
      continue;
    }
    if (typeof x === 'number' && typeof y === 'number') {
      return x - y;
    }
    // A number sorts before text at the same position ("4.5" before "4.a").
    if (typeof x === 'number') {
      return -1;
    }
    if (typeof y === 'number') {
      return 1;
    }
    return x < y ? -1 : 1;
  }
  return left.length - right.length;
}

/** Returns a new array sorted by RISQ code in natural order. */
export function sortByRisqCode<T>(items: readonly T[], getCode: (item: T) => string): T[] {
  return [...items].sort((a, b) => compareRisqCodes(getCode(a), getCode(b)));
}
